import React from 'react';
import Chip from '@material-ui/core/Chip';


const TransportationRequestChips = ({ customClasses, variant, transportationResources }) => {
    return (
        <>
            {
                transportationResources.map((resource, index) =>
                    <span key={index}>
                        <Chip
                            size="small"
                            label={resource.goingFromDestinationName}
                            variant={variant}
                            className={customClasses}
                            color="primary"
                        />
                        <Chip
                            size="small"
                            label={resource.goingToDestinationName}
                            className={customClasses}
                            variant={variant}
                            color="primary"
                        />
                    </span>
                )
            }
        </>
    )
}

export default TransportationRequestChips;